const isHaveTeammatePermission = (name, user) => {
  const currentUser = user;
  return currentUser?.isTeammate ? currentUser.role.permissions[name] === true : true;
};

export default isHaveTeammatePermission;
